// eslint-disable-next-line jira/import-whitelist
import { DefaultFilterFields } from '@jira/global-pages__directories-directory-base-v3/src/controllers/create-use-filter/index.tsx';

export const TableColumns = {
	Favourites: 'favourite',
	Key: 'key',
	Name: 'name',
	Type: 'type',
	Lead: 'lead',
	Category: 'category',
	LastIssueUpdate: 'last_issue_updated_time',
	Url: 'url',
	Action: 'actions',
} as const;

export type TableColumns = (typeof TableColumns)[keyof typeof TableColumns];

export const SortableColumns: TableColumns[] = [
	TableColumns.Favourites,
	TableColumns.Key,
	TableColumns.Name,
	TableColumns.Lead,
	TableColumns.Category,
	TableColumns.LastIssueUpdate,
];

export const FilterFields: {
	SortOrder: 'sortOrder';
	SortKey: 'sortKey';
	Page: 'page';
	Keyword: 'keyword';
	ProjectType: 'types';
	ProjectTypeLabel: 'ProjectTypeLabel';
	ProjectCategoryId: 'projectCategoryId';
	ProjectCategoryLabel: 'projectCategoryLabel';
} = {
	Keyword: 'keyword',
	ProjectType: 'types',
	ProjectTypeLabel: 'ProjectTypeLabel',
	ProjectCategoryId: 'projectCategoryId',
	ProjectCategoryLabel: 'projectCategoryLabel',
	...DefaultFilterFields,
};

export const filterAliasMap: {
	contains: 'keyword';
	selectedProjectType: 'types';
	selectedCategory: 'projectCategoryId';
} = {
	contains: FilterFields.Keyword,
	selectedProjectType: FilterFields.ProjectType,
	selectedCategory: FilterFields.ProjectCategoryId,
};

export const filterInitialState: {
	keyword: string;
	types: string;
	ProjectTypeLabel: string;
	projectCategoryId: string;
	projectCategoryLabel: string;
	sortOrder: string;
	sortKey: string;
	page: string;
} = {
	[FilterFields.Keyword]: '',
	[FilterFields.ProjectType]: '',
	[FilterFields.ProjectTypeLabel]: '',
	[FilterFields.ProjectCategoryId]: '',
	[FilterFields.ProjectCategoryLabel]: '',
	[FilterFields.SortOrder]: 'ASC',
	[FilterFields.SortKey]: TableColumns.Name,
	[FilterFields.Page]: '1',
};

export type FilterInitialState = typeof filterInitialState;

export const DEFAULT_LIMIT = 25;

export const PROJECTS_DIRECTORY_EXPERIENCE = 'viewProjectsDirectoryV3';
export const PROJECTS_DIRECTORY_ROUTE_NAME = 'projects-directory';
export const MANAGE_PROJECTS_DIRECTORY_EXPERIENCE = 'viewManageProjectsDirectoryV3';
export const CSM_PROJECTS_DIRECTORY_ROUTE_NAME = 'csm-projects-directory';
